import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import { writeRolsInputInfo } from "../functions/rol/writeRolsInputInfo";
import { createIpTable } from "../functions/createIpTable";

export const rolInfoModal = ({
  t,
  saveRolInfo,
  windowValues,
  setWindowValues,
  pricesRates,
  packInputFormat,
  packUpdateWindow,
  modalData,
  askDeleteMainInfo,
  closeMsg,
}: stdObject) => {
  return {
    title: modalData.title,
    mainColor: modalData.mainColor,
    style: { width: 460 },
    blocked: true,
    tabs: [
      { code: 0, label: t("p.permissions") },
      { code: 1, label: t("p.sections") },
      { code: 2, label: t("p.prices") },
      { code: 3, label: t("p.ip") },
    ],
    inputs: writeRolsInputInfo({
      t,
      modalData,
      windowValues,
      pricesRates,
      packInputFormat,
      packUpdateWindow,
    }),
    tableTab: 3,
    table: createIpTable({
      t,
      windowValues,
      setWindowValues,
    }),
    tableStyle: {
      maxHeight: 400,
      overflow: "auto",
      borderRadius: 0,
      border: "none",
    },
    buttons: [
      {
        label: modalData.id === "" ? t("p.create") : t("p.save"),
        onClick: saveRolInfo,
        color: colors.green,
      },
      modalData.id > 0
        ? {
            label: t("p.delete"),
            onClick: () => askDeleteMainInfo(),
            color: colors.red,
          }
        : null,
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
